// This file is generated by a script. Do not edit this file directly.
var _excluded = ["className", "label", "loading", "prefixIcon", "size", "suffixIcon", "variant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
import clsx from 'clsx';
import { cva } from 'cva';
import { Icon } from "../Icon";
import { Base } from "../Typography/Base";
import { BaseButton } from "./Base";
import { cn } from "../../common/utils";
import { Spinner } from "../Spinner";
var iconClasses = 'cop-h-3 cop-w-3 cop-fill-current cop-stroke-current';
var buttonVariants = cva({
  variants: {
    size: {
      sm: 'cop-py-[3px] cop-px-2',
      base: 'cop-px-3 cop-py-1'
    }
  },
  defaultVariants: {
    size: 'base'
  }
});

// functionally the same as Omit<BaseButtonProps, 'children' | 'variant'>
// we're using this instead because Omit breaks in the build

export var Button = function Button(_ref) {
  var className = _ref.className,
    label = _ref.label,
    loading = _ref.loading,
    prefixIcon = _ref.prefixIcon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'base' : _ref$size,
    suffixIcon = _ref.suffixIcon,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(BaseButton, _extends({
    "aria-label": loading ? 'Loading...' : props['aria-label'],
    className: cn(buttonVariants({
      size: size
    }), className),
    variant: variant === 'text' ? 'minimal' : variant
  }, props), loading ? /*#__PURE__*/React.createElement(Spinner, {
    size: 5
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, prefixIcon && /*#__PURE__*/React.createElement(Icon, {
    icon: prefixIcon,
    className: clsx('cop-pr-2', iconClasses)
  }), /*#__PURE__*/React.createElement(Base, {
    size: size === 'base' ? 'base' : 'xs',
    leading: size === 'base' ? '1' : '075',
    tag: "p",
    weight: "medium",
    variant: "body"
  }, label), suffixIcon && /*#__PURE__*/React.createElement(Icon, {
    icon: suffixIcon,
    className: clsx('cop-pl-1.5', iconClasses)
  })));
};
export * from "./Icon";
